<div class="p-3">
  <div class="page-title d-flex justify-content-between align-items-center">
    <h3>Admin Listing</h3>
    <p-button (click)="showDialogForCreate('right')" icon="pi pi-plus" label="Create Admin" severity="secondary"
      class="primary-btn"></p-button>
  </div>

  <!-- Search Field -->
  <div class="filters">
    <div class="filters-container w-100 m-0">
      <div class="p-1">
        <label for="search" class="dropdown-label">Search</label>
        <input id="searchField" type="text" class="form-control" placeholder="Search..." [(ngModel)]="filters.search"
          (input)="onFilterChange(); sanitizeInput($event)" 
          (keydown)="blockSpecialChars($event)"
          (paste)="blockSpecialCharsOnPaste($event)"
          (drop)="blockSpecialCharsOnDrop($event)"/>
      </div>
    </div>
  </div>

  <div class="users-listing p-4 mt-3 m-1">
    <p-table
      [value]="users"
      [lazy]="true"
      responsiveLayout="scroll"
      [paginator]="true"
      [rows]="10"
      [totalRecords]="totalRecords"
      (onLazyLoad)="fetchUsers($event)"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      [rowsPerPageOptions]="[10,20,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="id"># <p-sortIcon field="id"></p-sortIcon></th>
          <th pSortableColumn="first_name">First Name <p-sortIcon field="first_name"></p-sortIcon></th>
          <th pSortableColumn="last_name">Last Name <p-sortIcon field="last_name"></p-sortIcon></th>
          <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
          <th pSortableColumn="phone">Phone <p-sortIcon field="phone"></p-sortIcon></th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{ userIndex(user) }}</td>
          <td>{{ user.first_name }}</td>
          <td>{{ user.last_name }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.phone }}</td>
          <td [ngClass]="user.isActive ? 'activeStatus' : 'inactiveStatus'"><span>{{ user.isActive ? 'Active' : 'Inactive' }}</span></td>
          <td>
            <div class="d-flex align-items-center gap-2">
              <p-button class="icon-secondary-btn" pButton icon="pi pi-pencil"
                (click)="showDialogForEdit('right', user)"></p-button>
              <p-button *ngIf="user.user_type !== 'landlord'" class="icon-primary-btn" pButton icon="pi pi-trash"
                (click)="confirmDelete(user._id)"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog *ngIf="visible === true" [header]="selectedUser ? 'Update User' : 'Create User'" [modal]="true"
  [(visible)]="visible" [position]="position" [style]="{ width: '35%' }" draggable="false">
  <app-create-user *ngIf="visible === true" [userData]="selectedUser" (closeDialog)="onDialogClose()"></app-create-user>
</p-dialog>
<div class="dlt-confirmation-dialog">
  <p-confirmDialog></p-confirmDialog>
</div>
<p-toast></p-toast>